"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangePasswordHeader = ChangePasswordHeader;
exports.ChangePasswordForm = ChangePasswordForm;
exports.default = ChangePassword;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const react_native_1 = require("react-native");
const cancelable_promise_1 = require("cancelable-promise");
const react_i18next_1 = require("react-i18next");
const Theme_1 = require("../Theme");
const Helper_1 = require("../Helper");
const Button_1 = __importDefault(require("../components/Button"));
const Authentication_1 = __importDefault(require("../shared/Authentication"));
const ModalWrapper_1 = __importDefault(require("../components/ModalWrapper"));
const PasswordInput_1 = __importDefault(require("../components/PasswordInput"));
const AuthForms_1 = require("../partials/AuthForms");
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const UserContext_1 = require("../contexts/UserContext");
const MyProfile_1 = __importDefault(require("../api/MyProfile"));
const ThemeContext_1 = require("../ThemeContext");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        messageOuter: {
            marginTop: size != 'sm' ? 12 : 12,
            marginBottom: size != 'sm' ? -8 : 0,
        },
        message: {
            color: THEME.Red,
            fontSize: 14,
            fontWeight: '500',
            textAlign: 'center'
        }
    });
};
function ChangePasswordHeader(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Key, size: 20, color: THEME.Secondary }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1 }, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: { color: THEME.Text, fontWeight: '500', fontSize: (size != 'sm' ? 18 : 16), marginLeft: 8 }, children: t('profile:text.changePass') }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginBottom: -4, marginRight: -12 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { "aria-label": t('common:buttons.close'), hitSlop: 12, type: "borderless", onPress: props.onClose, children: (0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: Theme_1.ICONS.Regular.Xmark, size: 20, color: THEME.Text, style: { margin: 4 } }) }) })] }));
}
;
function ChangePasswordForm(props) {
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const promise = react_1.default.useRef(null);
    const [newPassword, setNewPassword] = react_1.default.useState('');
    const [confirmPassword, setConfirmPassword] = react_1.default.useState('');
    const [working, setWorking] = react_1.default.useState(false);
    const [message, setMessage] = react_1.default.useState(null);
    const [isValid, setIsValid] = react_1.default.useState(false);
    const [complexityError, setComplexityError] = react_1.default.useState(false);
    const [matchError, setMatchError] = react_1.default.useState(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const styles = useStyles();
    const verifyStrength = (pass, verify, useGlobal) => {
        const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
        var fallthrough = true;
        if (!passwordPattern.test(useGlobal ? newPassword : pass)) {
            setIsValid(false);
            setMessage(t('login:messages.weakPass'));
            setComplexityError(true);
            fallthrough = false;
        }
        if (pass != verify) {
            setIsValid(false);
            setMatchError(true);
            // Prioritize weak password message
            if (fallthrough) {
                setComplexityError(false);
                setMessage(t('login:messages.passMismatch'));
            }
            fallthrough = false;
        }
        else {
            // Clear the match error if the passwords match
            setMatchError(false);
        }
        if (!fallthrough) {
            return;
        }
        setIsValid(true);
        setMessage(null);
        setComplexityError(false);
        setMatchError(false);
    };
    const save = () => {
        if (!(newPassword?.length > 0 &&
            confirmPassword?.length > 0)) {
            setMessage(t('profile:messages.allReq'));
        }
        else if (newPassword != confirmPassword) {
            setMessage(t('login:messages.passMismatch'));
        }
        else {
            FirebaseAnalytics_1.default.LogEvent('feature_used', {
                'feature': 'Change Password',
                'client': userContext.client?.id,
                'employee': userContext.employee?.employeeId
            });
            setWorking(true);
            Authentication_1.default.UpdatePassword(newPassword).then(() => {
                promise.current?.cancel();
                promise.current = (0, cancelable_promise_1.cancelable)(userContext
                    .getToken()
                    .then((t) => MyProfile_1.default.sendPwdEmailConfirmation(t))
                    .catch((err) => {
                    console.error("Error sending password email confirmation", err);
                }));
                props.onSaved();
            }).catch((error) => {
                switch (error?.code) {
                    case 'auth/weak-password':
                        setMessage(t('profile:messages.weakPass'));
                        break;
                    default:
                        setMessage(t('profile:messages.otherErr'));
                        break;
                }
            }).finally(() => {
                setWorking(false);
            });
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginVertical: 8 }, children: (0, jsx_runtime_1.jsx)(PasswordInput_1.default, { kind: "paper", error: complexityError, label: t('profile:labels.newPass') + ' *', "aria-label": t('profile:labels.newPass'), value: newPassword ?? '', mode: "outlined", onChangeText: (v) => {
                        verifyStrength(v, confirmPassword, false);
                        setNewPassword(v);
                    }, showCapsWarning: Helper_1.Helper.isPlatformWeb }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { marginVertical: 8 }, children: (0, jsx_runtime_1.jsx)(PasswordInput_1.default, { kind: "paper", error: matchError, label: t('profile:labels.newPassConf') + ' *', "aria-label": t('profile:labels.newPassConf'), value: confirmPassword ?? '', mode: "outlined", onChangeText: (v) => {
                        verifyStrength(v, newPassword, true);
                        setConfirmPassword(v);
                    }, onSubmitEditing: save, showCapsWarning: Helper_1.Helper.isPlatformWeb }) }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: { flexDirection: 'row', marginTop: 12, marginHorizontal: -6 }, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 1, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { type: "outline", extraPadding: 4, text: t('common:buttons.cancel'), onPress: props.onCancel }) }), (0, jsx_runtime_1.jsx)(react_native_1.View, { style: { flex: 2, marginHorizontal: 6 }, children: (0, jsx_runtime_1.jsx)(Button_1.default, { disabled: working || !isValid, extraPadding: 4, text: t('profile:buttons.savePass'), onPress: save }) })] }), message &&
                (0, jsx_runtime_1.jsx)(react_native_1.View, { style: styles.messageOuter, children: (0, jsx_runtime_1.jsx)(react_native_1.Text, { style: styles.message, children: message }) })] }));
}
;
function ChangePassword(props) {
    const [step, setStep] = react_1.default.useState('authenticate');
    return ((0, jsx_runtime_1.jsxs)(ModalWrapper_1.default, { navigation: props.navigation, children: [(0, jsx_runtime_1.jsx)(react_native_1.View, { style: { paddingHorizontal: 12, paddingTop: 8, paddingBottom: 2 }, children: (0, jsx_runtime_1.jsx)(ChangePasswordHeader, { onClose: props.onClose ?? props.navigation.goBack }) }), (0, jsx_runtime_1.jsxs)(react_native_1.ScrollView, { contentContainerStyle: { paddingHorizontal: 12, paddingBottom: 12 }, keyboardShouldPersistTaps: "handled", children: [(step == 'authenticate') &&
                        (0, jsx_runtime_1.jsx)(AuthForms_1.AuthReauthenticate, { onCancel: props.onClose ?? props.navigation.goBack, onSuccess: () => { setStep('change'); } }), (step == 'change') &&
                        (0, jsx_runtime_1.jsx)(ChangePasswordForm, { onCancel: props.onClose ?? props.navigation.goBack, onSaved: props.onSave ?? props.navigation.goBack })] })] }));
}
;
